export const environment = {
	production: false,
	webStorageUrl: 'https://ssiwebstoragedev.blob.core.windows.net',
  apiBaseURL: 'https://rr-wus3-pubweb-api-radiusauto-dev-hee5afbwf2dhg0an.westus3-01.azurewebsites.net'
  // apiBaseURL: 'http://localhost:5140'
}
